module.exports = "https://dashboard.cdn.gifty.nl/6398/images/truck.svg?283e2106a707df2f4104a49e1c650408";